(() => {
  if (customElements.get('fizzy-natural-flavors')) return;
  customElements.define('fizzy-natural-flavors', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.fnf-open');
      let previousOverflow;
      opener.addEventListener('click', () => {
        if (dialog.open) return;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        dialog.scrollTop = 0;
        this.querySelector('.fnf-modal__content').scrollTop = 0;
        document.body.style.overflow = 'hidden';
      });
      this.querySelectorAll('[data-fnf-close]').forEach(button => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const stops = [...dialog.querySelectorAll('button, a[href]')];
        const first = stops[0];
        const last = stops[stops.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        opener.focus({ preventScroll: true });
      });
      // Safari fallback for native backdrop dismissal.
      if (!('closedBy' in HTMLDialogElement.prototype)) {
        let backdropStart = false;
        const outside = event => {
          const rect = dialog.getBoundingClientRect();
          return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        };
        dialog.addEventListener('pointerdown', event => { backdropStart = outside(event); });
        dialog.addEventListener('click', event => {
          if (backdropStart && outside(event)) dialog.close();
          backdropStart = false;
        });
      }
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
    }
  });
})();
